export class SearchPromotedFileCriteria {
    promoteTiers: string[];
    fileName?: string;
  
    SearchReportCriteria(): void {
      this.promoteTiers = [];
      this.fileName = "";
    }
  }